import { render, staticRenderFns } from "./FinalStep.vue?vue&type=template&id=635bb840&scoped=true&"
import script from "./FinalStep.vue?vue&type=script&lang=js&"
export * from "./FinalStep.vue?vue&type=script&lang=js&"
import style0 from "./FinalStep.vue?vue&type=style&index=0&id=635bb840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bb840",
  null
  
)

export default component.exports